import { render, staticRenderFns } from "./province-selector.component.vue?vue&type=template&id=43df4997"
import script from "./province-selector.component.vue?vue&type=script&lang=js"
export * from "./province-selector.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports